import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AuthResolver implements Resolve<boolean> {

  constructor(private auth: AuthService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.auth.ready();
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/auth/auth-resolver.ts